import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-training-selection-modal',
  standalone: false,
  templateUrl: './training-selection-modal.component.html',
  styleUrl: './training-selection-modal.component.scss'
})
export class TrainingSelectionModalComponent {
  constructor(public dialogRef: MatDialogRef<TrainingSelectionModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  cardData: any = this.data?.data || {};


  onContinue(): void {
    this.dialogRef.close('continue');
  }


}
